import styled from 'styled-components'
import Fonts from '../../theme/fonts'
import Colors from '../../theme/colors'
import React from 'react'

const styles = styled.div<{icon: React.ReactElement}>`
  display: flex;
  position: relative;
  align-items: center;
  width: 100%;
  line-height: 24px;
  font-family: ${Fonts.fontFamilies.Inter};
  font-size: ${Fonts.fontSizes.p16};

  input {
    width: 100%;
    padding-left: ${props => (props.icon ? '45px' : '17px')};
    background: none !important;
    color: ${Colors.Primary.GreyDark};
  }

  .control-icon {
    width: 16px;
    height: 16px;

    margin-left: -32px;

    path {
      fill: ${Colors.Primary.GreyDark};
    }

    &.valid {
      path {
        fill: ${Colors.Action.SuccessGreen};
      }
    }

    &.invalid {
      path {
        fill: ${Colors.Action.ErrorRed};
      }
    }

    &:hover {
      cursor: pointer;
    }

    &.disabled {
      pointer-events: none;

      path {
        fill: #bdbdbd;
      }
    }
  }

  .left-side-icon {
    margin-right: -32px;
    z-index: 1;
    display: inline-flex;

    svg {
      width: 16px;
      height: 16px;
      path {
        fill: ${Colors.Primary.GreyDark};
      }
    }
  }

`

export default styles
